import * as React from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Stack from '@mui/material/Stack';
import { Link, useNavigate } from 'react-router-dom';

export default function MenuDropDownGold({setVal,setSilvDOpen,silvDOpen,setPlatDOpen,platDOpen,goldDOpen,setGoldDOpen}) {
      const [open, setOpen] = React.useState(false);
      const anchorRef = React.useRef<HTMLButtonElement>(null);
      const parentDivRef = React.useRef(null);
      const nav = useNavigate()

      const handleToggle = () => {
        setGoldDOpen((prevOpen) => !prevOpen);
        setSilvDOpen(false)
        setPlatDOpen(false)
      };
      function openAllGold(){
        setVal(1)
        nav("/Gold",{state:{ breadCrumb: "/Gold" }} )
      }

  const closeDrop = (event) =>{
    setGoldDOpen(false)
    setSilvDOpen(false)
    setPlatDOpen(false)
  }
  let goldcoincats= [{name:"Gold Coins",bread:'/Gold/Gold-Coins'},{name:"U.S. Gold Coins",bread:'/Gold/Gold-Coins/U.S.-Gold-Coins'}, 
  {name:"Australian Gold Coins",bread:'/Gold/Gold-Coins/Australian-Gold-Coins'}, 
  {name:"Austrian Gold Coins",bread:'/Gold/Gold-Coins/Austrian-Gold-Coins'}, 
  {name:"British Gold Coins",bread:'/Gold/Gold-Coins/British-Gold-Coins'},{name:"Canadian Gold Coins",bread:'/Gold/Gold-Coins/Canadian-Gold-Coins'},{name:"Chinese Gold Coins",bread:'/Gold/Gold-Coins/Chinese-Gold-Coins'},{name:"Mexican Gold Coins",bread:'/Gold/Gold-Coins/Mexican-Gold-Coins'},{name:"African Gold Coins",bread:'/Gold/Gold-Coins/African-Gold-Coins'},{name:"Other Gold Coins",bread:'/Gold/Gold-Coins/Other-Gold-Coins'}]
  
  let goldbarcats =[{name:"Gold Bars",bread:'/Gold/Gold-Bars'},
  {name:"1 oz Gold Bars",bread:'/Gold/Gold-Bars/1-oz-Gold-Bars'},
  {name:"5 oz Gold Bars",bread:'/Gold/Gold-Bars/5-oz-Gold-Bars'},
  {name:"10 oz Gold Bars",bread:'/Gold/Gold-Bars/10-oz-Gold-Bars'},
  {name:"Fractional Gold Bars",bread:'/Gold/Gold-Bars/Fractional-Gold-Bars'}]
    
      return (
        <Stack direction="row" spacing={2} className='goldBack linkstyle'>
          <div ref={parentDivRef} className='goldBack'>
            <Button
              ref={anchorRef}
              id="composition-button"
              aria-controls={open ? 'composition-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              onClick={openAllGold}
              onMouseEnter={handleToggle}
              style={{paddingTop:12,marginRight:10}}
              className='goldBack'
            >
              Gold
            </Button>
            <Popper
              open={goldDOpen}
              anchorEl={anchorRef.current}
              role={undefined}
              placement='bottom-start'
              transition
              disablePortal
              style={{background:'transparent',zIndex:10}}
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === 'bottom-start' ? 'left top' : 'left bottom',
                  }}
                >
                  <Paper style={{borderRadius:15}}>
                    <ClickAwayListener onClickAway={closeDrop}>
                      <div className='fb dropdownmenu'>
                      <div className='toptri fade-up goldtop'></div>
                        <div>
                        {goldcoincats.map((item,index)=>{
                          let urll = "/" + item.name.replaceAll(" ", "-")

                        return(
                          <>
                            <Link to={item.bread} state={{ breadCrumb: item.bread}} className={index == 0 ? '':'subMenu'} onClick={()=>{setGoldDOpen(false);setVal(1)}}>
                              {item.name}
                              </Link><br/>
                          </>

                        )
                        })}

                        </div>
                        <div>
                        {goldbarcats.map((item,index)=>{
                          let urll = "/" + item.name.replaceAll(" ", "-")

                        return(
                          <>
                            <Link to={item.bread} state={{ breadCrumb: item.bread}} className={index == 0 ? '':'subMenu'} onClick={()=>{setGoldDOpen(false);setVal(1)}}>
                              {item.name}
                              </Link><br/>
                          </>

                        )
                        })}
                      <Link to={"Other-Gold"} state={{ breadCrumb: '/Gold/Other-Gold'}} onClick={()=>{setGoldDOpen(false);setVal(1)}}>
                              Other Gold
                        </Link><br/>
                        </div>

                        </div>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
        </Stack>
      );
    }